import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar.tsx";
import Breadcrumb from "../components/Breadcrumb.tsx";
import Container from "../components/Container.tsx";
import Section1 from "../components/Main/Section1.tsx";
import Section2 from "../components/Main/Section2.tsx";
import Section3 from "../components/Main/Section3.tsx";
import Section4 from "../components/Main/Section4.tsx";
import Section5 from "../components/Main/Section5.tsx";
import Section6 from "../components/Main/Section6.tsx";
import Section7 from "../components/Main/Section7.tsx";
import Section8 from "../components/Main/Section8.tsx";
import Section9 from "../components/Main/Section9.tsx";
import NavbarMobile from "../components/NavbarMobile.tsx";
import Footer from "../components/Main/Footer.tsx";
import { useSelector } from "react-redux";
import { Breadcrumbs } from "@mui/material";

const Main = () => {
  const reduxStateLanguage = useSelector((state: any) => state.language.value);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1180);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1180);
    };

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Cleanup listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [windowWidth]);

  useEffect(() => {
    console.log("Redux State: ", reduxStateLanguage);
  }, [reduxStateLanguage]);

  return (
    <Container>
      {isMobile ? (
        <NavbarMobile lang={reduxStateLanguage} />
      ) : (
        <Navbar lang={reduxStateLanguage} />
      )}
      {/* <Breadcrumb /> */}
      <Section1 lang={reduxStateLanguage} />
      <Section2 />
      <Section3 />
      <Section4 />
      <Section5 />
      <Section6 />
      <Section7 />
      <Section8 />
      <Section9 />
      <Footer />
    </Container>
  );
};

export default Main;
